// extracted by css-extract-rspack-plugin
export default {"logOutput":"bF17Z"};